module.exports = __webpack_public_path__ + "static/media/fernando.5e0b7e6e.jpg";